module.exports = __webpack_public_path__ + "img/result_ls_lens_up.82529af7.jpg";